import requester from '../utils/requester';
import Platform from '../platform';
import config from '../config';
import apiCubic from '../config/api-cubic';
import { store } from 'index';

import {
  getContractNumberSelector,
  getIsLoggedInSelector,
  getLoginData,
  getProfileId,
} from 'reducers/profile/selectors';

const postEvent = (params) => {
  const { eventGroup, eventName = null, eventValue = null, addInfo = null } = params;
  const now = new Date();
  const eventTime = now.toISOString();
  const storeState = store.getState();

  const isLoggedIn = getIsLoggedInSelector(storeState);
  const loginData = getLoginData(storeState);
  const nickname = isLoggedIn && loginData ? loginData.userFlag : null;

  const dataJson = {
    sourceName: 'SmartTV',
    sourceVersion: config.appVersion,
    deviceId: Platform.getUID(),
    deviceType: Platform.getDeviceType(),
    deviceFullType: 'TV ' + Platform.getModelYear(),
    deviceVendor: Platform.getBrand(),
    deviceModel: Platform.getModelName(),
    deviceOs: Platform.getName(),
    deviceOsVersion: Platform.getPlatformVersion(),
    deviceFirmwareVersion: Platform.getFirmwareVersion(),
    deviceUuid: Platform.getUID(),
    device3d: false,
    deviceUhd: Platform.supportsUHD(),
    deviceHdr: Platform.supportsHDR(),
    typeOfConnection: Platform.getConnectionType(),
    eventGroup: eventGroup,
    eventName: eventName,
    eventValue: eventValue,
    isVoliaClient: true,
    contractCode: getContractNumberSelector(storeState),
    profileId: getProfileId(storeState),
    addInfo: addInfo,
    eventTime: eventTime,
    nickname: nickname,
  };

  //TEMP for Volia tests
  //console.log('----- Inner Analytics -----');
  //console.log({ eventGroup, eventName, eventValue, addInfo });
  //console.log('----- END -----');

  _postRequest(dataJson);
};

function _postRequest(dataJson) {
  const authToken = btoa(`${apiCubic.users.billing.login}:${apiCubic.users.billing.pass}`);

  const dataToPOST = [dataJson];

  try {
    requester({
      method: 'post',
      url: apiCubic.host + apiCubic.endpoints.innerAnalytics,
      appendParams: false,
      extendHeadersWithSession: false,
      headers: {
        Authorization: `Basic ${authToken}`,
      },
      data: dataToPOST,
    });
  } catch (error) {
    console.error(error);
  }
}

export default {
  postEvent,
};
